// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606030142/js/" + chunkId + "." + {"44":"00c68ee1","225":"e54262a7","481":"dfad9260","486":"e55335ea","770":"98713504"}[chunkId] + ".0.24559280196213928.chunk.js";
};